import { render, staticRenderFns } from "./CardMealLog.vue?vue&type=template&id=4847a4d5"
import script from "./CardMealLog.vue?vue&type=script&lang=js"
export * from "./CardMealLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports